// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"map-module--wrapper--3BY1q","placeholder":"map-module--placeholder--2o8yn","iframe":"map-module--iframe--2a8Iv"};